export const passwordValidation = (password: string): boolean => {
  const alphabetMatch = /[a-zA-Z]/.test(password);
  const digitMatch = /[0-9]/.test(password);
  const specialCharacterMatch = /[!@#$%^*+=\-_?]/.test(password);

  // 대소문자, 특수문자, 숫자 중 2가지 이상을 포함하는지
  const isValidChar =
    [alphabetMatch, digitMatch, specialCharacterMatch].filter(Boolean).length >=
    2;

  // 8자리 이상 20자리 미만인지
  const lengthMatch = /^.{8,20}$/.test(password);

  // 허용되지 않는 문자가 있는지
  const otherCharMatch = /[^a-zA-Z0-9!@#$%^*+=\-_?]/.test(password);

  // 공백이 없는지
  const noSpaceMatch = /^\S*$/.test(password);

  return isValidChar && lengthMatch && !otherCharMatch && noSpaceMatch;
};

export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^*+=-_?])(?=.*[0-9]).{8,20}$/;

export const emailRegex =
  // eslint-disable-next-line no-useless-escape
  /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/;

export const nameRegex = /^[A-Za-z0-9가-힣ㄱ-ㅎ\s]*$/;

export const phoneRegex = /^(01[0|1|6|7|8|9])-?([\d*]{3,4})-?([\d*]{4})$/;

export const areaCodeRegex =
  /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/;

export const phoneWithHyphenRegex = /^(\d{3})-([\d*]{3,4})-([\d*]{4})$/;

export const businessNumberRegex = /^([\d*]{3})-?([\d*]{2})-?([\d*]{5})$/;

export const urlRegex =
  // eslint-disable-next-line no-useless-escape
  /^((http|https):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/;

export const inAppLinkRegex =
  // eslint-disable-next-line no-useless-escape
  /^\/app\//;
